import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fc8dd88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "class-leader-board" }
const _hoisted_2 = {
  key: 0,
  class: "class-leader-board-table"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "rank-text" }
const _hoisted_5 = { class: "profile-picture" }
const _hoisted_6 = { class: "name-text" }
const _hoisted_7 = { class: "points-text" }
const _hoisted_8 = {
  key: 1,
  class: "class-leader-board-empty"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No students in this class", -1))
const _hoisted_10 = [
  _hoisted_9
]

import { User } from '../../models/User';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassLeaderBoard',
  props: {
    studentList: null
  },
  setup(__props: any) {

const props = __props as {
  studentList: User[];
}



const sortedStudents = computed(() => {
  return props.studentList
    .concat()
    .sort((a, b) => (b.score.sum() || 0) - (a.score.sum() || 0));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.studentList.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedStudents), (student, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: student.uid,
                class: "class-leader-board-item border-bottom"
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(index + 1), 1),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(student.firstName[0] + student.lastName[0]), 1),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(student.firstName) + " " + _toDisplayString(student.lastName), 1)
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(student.score.sum()), 1)
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
  ]))
}
}

})